import PropTypes from "prop-types";

export const ProductCardProps = {
    product: PropTypes.shape({
        id: PropTypes.number,
        name: PropTypes.string,
        price: PropTypes.string,
        attributes: PropTypes.arrayOf(
            PropTypes.shape({
                id: PropTypes.number,
                name: PropTypes.string,
                slug: PropTypes.string,
            })
        ),
        image: PropTypes.shape({
            alt: PropTypes.string,
            id: PropTypes.number,
            name: PropTypes.string,
            sizes: PropTypes.string,
            src: PropTypes.string,
            srcset: PropTypes.string,
            thumbnail: PropTypes.string,
        }),
        ingredients: PropTypes.arrayOf(
            PropTypes.shape({
                name: PropTypes.string,
            })
        ),
        url: PropTypes.string.isRequired,
        intolerances: PropTypes.arrayOf(
            PropTypes.shape({
                id: PropTypes.number,
                name: PropTypes.string,
                slug: PropTypes.string,
            })
        ),
    }),
    inStock: PropTypes.bool,
};

export const SeeIngredientsProps = {
    onClick: PropTypes.func,
};

export const OverlayProps = {
    productName: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
    onClose: PropTypes.func,
    open: PropTypes.bool,
    ingredients: PropTypes.arrayOf(
        PropTypes.shape({
            name: PropTypes.string,
        })
    ),
    envDetails: PropTypes.shape({
        energy: PropTypes.number,
        weight: PropTypes.number,
        co2: PropTypes.number,
    }),
    customClass: PropTypes.string,
    url: PropTypes.string.isRequired,
};
